var map = {
	"./1.png": 1032,
	"./1.svg": 1033,
	"./10.png": 1034,
	"./11.png": 1035,
	"./12.png": 1036,
	"./13.png": 1037,
	"./2.png": 1038,
	"./2.svg": 1039,
	"./3.png": 1040,
	"./3.svg": 1041,
	"./4.png": 1042,
	"./4.svg": 1043,
	"./5.png": 1044,
	"./6.png": 1045,
	"./7.png": 1046,
	"./8.png": 1047,
	"./9.png": 1048,
	"./card-bg.png": 1049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1217;